// extracted by mini-css-extract-plugin
export var localhostBackground = "_2018-module--localhostBackground--2iX24";
export var localhostLogoClass = "_2018-module--localhostLogoClass--2DYR9";